import React, { useState, useEffect } from "react";
import "../aseets/css/GmTestimonials.css";
import founder from '../aseets/gallery/founder.jfif'
import manager from '../aseets/gallery/manager.jfif'
import HOD from '../aseets/gallery/HOD.jfif'

const testimonials = [
  {
    id: 1,
    name: "Kathrine Katija",
    role: "Marketing Manager, ABC Ad Services",
    quote:
      "Our ad campaigns finally speak to the right audience with clarity resulting in high CTR and ROI.",
    img: manager,
    rating: 4,
  },
  {
    id: 2,
    name: "Daniel Morris",
    role: "Founder, GrowthLab",
    quote:
      "Their strategic clarity helped us stop guessing and start scaling with confidence.",
    img: founder,
    rating: 5,
  },
  {
    id: 3,
    name: "Sophia Lee",
    role: "Brand Head, Elevate",
    quote:
      "A rare blend of creativity and performance thinking. Results followed naturally.",
    img: HOD,
    rating: 4,
  },
];



const GmTestimonials = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
  const section = document.querySelector(".gm-testimonial");
  if (!section) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        section.classList.add("show");
        observer.disconnect(); // trigger once
      }
    },
    {
      threshold: 0.3, // section is 30% visible
    }
  );

  observer.observe(section);

  return () => observer.disconnect();
}, []);



  return (
    <section className="gm-testimonial">
      {/* HEADER */}
      <div className="gm-testimonial-header">
        <span className="gm-testimonial-eyebrow">WHAT CLIENTS SAY</span>
        <h2 className="gm-testimonial-title">
          Honest Feedback <br /> From Valued People
        </h2>
        <p className="gm-testimonial-sub">
          Feedback from businesses and individuals who trusted us to
          elevate their brands.
        </p>
      </div>

      {/* CONTENT */}
      <div className="gm-testimonial-body">
        {/* AVATARS */}
        <div className="gm-testimonial-avatars">
          {testimonials.map((t, i) => (
            <button
              key={t.id}
              className={`gm-avatar ${active === i ? "gm-avatar-active" : ""
                }`}
              onClick={() => setActive(i)}
            >
              <img src={t.img} alt={t.name} />
            </button>
          ))}
        </div>

        {/* CARD */}
        <div className="gm-testimonial-card">
          <p className="gm-testimonial-quote">
            “{testimonials[active].quote}”
          </p>

          <div className="gm-testimonial-meta">
            <strong>{testimonials[active].name}</strong>
            <span>{testimonials[active].role}</span>
          </div>

          <div className="gm-testimonial-divider" />

          <div className="gm-testimonial-stars">
            {"★".repeat(testimonials[active].rating)}
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="gm-testimonial-cta">
        <span>See how impactful strategy makes a difference</span>
        <button className="gm-testimonial-btn">SCHEDULE A CALL</button>
      </div>
    </section>
  );
};

export default GmTestimonials;
